import { useI18n } from 'vue-i18n';

const pt = {
  MERGE_DIALOG: {
    TITLE: 'Mesclar contato',
    DESCRIPTION: 'Junte dois cadastros da mesma pessoa em um só.',
    STEP: 'Passo {step} de 2',
    SEARCH_LABEL: 'Com qual contato você quer mesclar?',
    SEARCH_PLACEHOLDER: 'Buscar por nome, telefone ou e-mail',
    SELECT: 'Selecionar',
    DUPLICATE: 'PROVÁVEL DUPLICADO',
    SAME_PHONE: 'mesmo telefone',
    SAME_EMAIL: 'mesmo e-mail',
    EMPTY: 'Nenhum contato encontrado.',
    SEARCHING: 'Buscando contatos…',
    LOADING: 'Carregando os dados dos contatos…',
    LOAD_ERROR: 'Não foi possível carregar os contatos. Tente novamente.',
    CANCEL: 'Cancelar',
    CLOSE: 'Fechar',
    BACK: 'Trocar contato',
    SWAP: 'Inverter o contato principal',
    CONFIRM: 'Mesclar contatos',
    REMOVED: 'SERÁ EXCLUÍDO',
    PRIMARY: 'FICA · PRINCIPAL',
    CONNECTIONS: '{count} conexão | {count} conexões',
    CONVERSATIONS: '{count} conversa | {count} conversas',
    EMAIL: 'E-mail',
    WHATSAPP: 'WhatsApp',
    INSTAGRAM: 'Instagram',
    MESSENGER: 'Messenger',
    OTHER: 'Outro',
    OWNER: 'Responsável',
    NO_OWNER: 'Sem responsável',
    TEAM: 'Equipe',
    COMPANY: 'Empresa',
    SUMMARY: 'O QUE ACONTECE',
    MOVED: '{conversations} e {connections} passam para {name}',
    FIELDS:
      'Os dados de {name} têm preferência. Dados complementares do outro cadastro são incorporados.',
    IDENTITIES: 'Notas e identidades dos dois contatos são preservadas.',
    OWNER_RULES:
      'O responsável segue as regras de carteira e o histórico dos atendimentos.',
    WARNING:
      'O cadastro "{name}" será excluído. Essa ação não pode ser desfeita.',
    SUCCESS: 'Contatos mesclados com sucesso.',
    ERROR: 'Não foi possível mesclar os contatos. Tente novamente.',
  },
};
const en = {
  MERGE_DIALOG: {
    TITLE: 'Merge contact',
    DESCRIPTION: 'Combine two records of the same person into one.',
    STEP: 'Step {step} of 2',
    SEARCH_LABEL: 'Which contact do you want to merge with?',
    SEARCH_PLACEHOLDER: 'Search by name, phone or email',
    SELECT: 'Select',
    DUPLICATE: 'LIKELY DUPLICATE',
    SAME_PHONE: 'same phone',
    SAME_EMAIL: 'same email',
    EMPTY: 'No contacts found.',
    SEARCHING: 'Searching contacts…',
    LOADING: 'Loading contact details…',
    LOAD_ERROR: 'Could not load contacts. Please try again.',
    CANCEL: 'Cancel',
    CLOSE: 'Close',
    BACK: 'Change contact',
    SWAP: 'Switch the primary contact',
    CONFIRM: 'Merge contacts',
    REMOVED: 'WILL BE DELETED',
    PRIMARY: 'KEPT · PRIMARY',
    CONNECTIONS: '{count} connection | {count} connections',
    CONVERSATIONS: '{count} conversation | {count} conversations',
    EMAIL: 'Email',
    WHATSAPP: 'WhatsApp',
    INSTAGRAM: 'Instagram',
    MESSENGER: 'Messenger',
    OTHER: 'Other',
    OWNER: 'Owner',
    NO_OWNER: 'No owner',
    TEAM: 'Team',
    COMPANY: 'Company',
    SUMMARY: 'WHAT HAPPENS',
    MOVED: '{conversations} and {connections} move to {name}',
    FIELDS:
      'Data from {name} takes priority. Complementary data from the other record is incorporated.',
    IDENTITIES: 'Notes and identities from both contacts are preserved.',
    OWNER_RULES:
      'The owner follows portfolio rules and the conversation history.',
    WARNING:
      'The record "{name}" will be deleted. This action cannot be undone.',
    SUCCESS: 'Contacts merged successfully.',
    ERROR: 'Could not merge contacts. Please try again.',
  },
};
export const useContactMergeI18n = () =>
  useI18n({ useScope: 'local', messages: { en, pt, pt_BR: pt, 'pt-BR': pt } });
